import { Link } from "react-router-dom";
import { ScrollText, Play } from "lucide-react";

export const GETTING_STARTED_ID = "getting-started";

export function GettingStartedCard() {
  return (
    <Link
      to={`/course/${GETTING_STARTED_ID}`}
      className="group block relative overflow-hidden border border-amber-500/30 bg-gradient-to-r from-[#241a08] via-[#312413] to-[#1a1206] p-6 md:p-7"
      data-testid="getting-started-card"
    >
      <div className="absolute inset-0 opacity-[0.15] pointer-events-none"
        style={{ background: "radial-gradient(circle at 15% 30%, rgba(245,190,90,0.5), transparent 45%), radial-gradient(circle at 85% 80%, rgba(212,160,60,0.35), transparent 40%)" }} />
      <div className="relative flex items-center gap-5">
        <div className="h-12 w-12 shrink-0 flex items-center justify-center bg-amber-400/15 border border-amber-400/30">
          <ScrollText className="h-6 w-6 text-amber-300" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-amber-400/90 mb-1">Getting Started</p>
          <h3 className="font-display text-lg md:text-xl font-extrabold tracking-tight text-amber-50 leading-tight">
            All About Learn Me in 2 Minutes
          </h3>
          <p className="text-sm text-amber-100/60 mt-0.5">The Annals of Knowledge — your wise two-minute tour of the platform.</p>
        </div>
        <span className="hidden sm:inline-flex items-center gap-2 shrink-0 text-sm font-semibold text-[#1a1206] bg-amber-300 group-hover:bg-amber-200 transition-colors px-4 h-10">
          <Play className="h-4 w-4" /> Watch
        </span>
      </div>
    </Link>
  );
}
